import * as reportConstants from "../constants/report.constants";
import { ReportAction } from '../actions'
import { IReportEntries } from "../contracts/IReportEntries";
import { TimePeriod } from 'src/contracts/IReportFilters';
import { SortOrder, IReportDto } from 'src/services';
import { ILocalizedError } from 'src/i18n/error-localization';

const initialState: IReportEntries = {
    currentPage: 1,
    entities: [],
    error: null,
    filters: { timePeriod: TimePeriod.AllTime, searchString: undefined, startDate: undefined, endDate: undefined },
    isLoading: false,
    pageSize: 25,
    sort: { sortBy: 'creationTime', order: SortOrder.Desc },
    totalPages: 1
}

export const reportsReducer = (state: IReportEntries = initialState, action: ReportAction) => {
    switch (action.type) {
        case reportConstants.REPORT_SUCCESS:
            return handleRequestCompleted(state, action.payload)
        case reportConstants.REPORT_REQUEST:
            return handleRequestInitiated(state);
        case reportConstants.REPORT_FAILURE:
            return handleRequestFailed(state, action.payload)
        case reportConstants.REPORT_UPDATE_SUCCESS:
            return handleUpdateCompleted(state, action.payload)            
    }

    return state;
}

const handleRequestInitiated = (state: IReportEntries) => {
    const newState = Object.assign({}, state)
    newState.isLoading = true
    return newState
}

const handleRequestFailed = (state: IReportEntries, payload: ILocalizedError) => {
    const newState = Object.assign({}, state)
    newState.isLoading = false
    newState.error = payload
    return newState
}

const handleUpdateCompleted = (state: IReportEntries, payload: IReportDto) => {
    const newState = Object.assign({}, state)
    newState.isLoading = false

    const index = newState.entities.findIndex(a => a.id === payload.id)
    newState.entities[index] = payload

    return newState
}

const handleRequestCompleted = (state: IReportEntries, payload: IReportEntries) => {
    const newState = Object.assign({}, state)
    newState.isLoading = payload.isLoading
    newState.entities = payload.entities
    newState.currentPage = payload.currentPage
    newState.totalPages = payload.totalPages
    newState.pageSize = payload.pageSize

    if (payload.filters) {
        const newFilters = Object.assign({}, state.filters)
        newFilters.searchString = payload.filters!.searchString
        newFilters.startDate = payload.filters!.startDate
        newFilters.endDate = payload.filters!.endDate
        newFilters.timePeriod = payload.filters!.timePeriod

        newState.filters = newFilters
    }

    if (payload.sort) {
        const newSort = Object.assign({}, state.sort)
        newSort.sortBy = payload.sort!.sortBy
        newSort.order = payload.sort!.order

        newState.sort = newSort
    }

    return newState
}


// WEBPACK FOOTER //
// ./src/reducers/reports.reducer.ts